// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const ButtonContract = contract({
  name: "Button",
  description: "Any clickable action. Use `iconOnly` for square icon-only buttons (at any size), variant=\"link\" for inline links that should look like Button, the `raised` prop for high-commitment / weighty actions where the chrome can afford a tactile \"physical key\" treatment (composes with any variant; variant=\"raised\" remains the neutral-key alias). A Button placed next to a TabsList of the same size lines up edge-to-edge without per-call overrides.",
  import: "@gradeui/ui",
  aliases: ["button","push button","plain button","bordered button","destructive button","capsule button","link button","action button","cta","raised button","pill button","key button"],
  element: "button",
  composesWith: ["Dialog","DropdownMenu","Tooltip","Card (in CardFooter)","Row","Form controls"],
  styleDefaults: {"Button":"inline-flex cursor-pointer items-center justify-center whitespace-nowrap rounded-md font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 bg-primary text-primary-foreground hover:bg-primary/90 h-8 gap-1.5 px-3 text-base [&_svg]:size-4"},
  variantDefaults: {"variant":"default","size":"md"},
  props: {
  "variant": {
      schema: z.enum(["default", "destructive", "outline", "secondary", "ghost", "link", "raised"]).optional(),
      design: "knob",
      description: "`raised` here is a back-compat alias (the raised TRAIT on a neutral key surface); prefer the `raised` prop",
  },
  "raised": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "presence TRAIT: tactile elevation (bevel + drop + hover glow + pressed sink) layered onto ANY variant — raised primary, raised outline, etc. Glow tone reads --btn-glow → --accent-glow → --selected-glow; override per-button via style={{ \"--btn-glow\": \"var(--warning)\" }}",
  },
  "size": {
      schema: z.enum(["2xs", "xs", "sm", "md", "lg"]).optional(),
      design: "knob",
      description: "t-shirt scale aligned with Tabs/ToggleGroup heights (2xs=h-5, xs=h-6, sm=h-7, md=h-8, lg=h-10). 2xs/xs are the dense tool-panel sizes (match Figma Button size=2xs/xs). `default` still works as an alias for `md`.",
  },
  "iconOnly": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "squares the button at the current `size` height (w = h, no horizontal padding) for icon-only buttons; the icon child is centered. This is THE way to make a square icon button at any density (sm→28², 2xs→20²).",
  },
  "asChild": {
      schema: z.boolean().optional(),
      design: "plumbing",
      description: "renders as the child element (use to wrap <a>/<Link>)",
  },
  "disabled": {
      schema: z.boolean().optional(),
      design: "knob",
  },
  },
});
